import NFAnalytics from "shared/helpers/analytics/NFAnalytics";

export const onViewBagClick = () => {
    NFAnalytics.updateDatalayerBeforeNext({ isViewedFromNudge: 'yes' });
    
};